import { DailyLessonDaysLesson } from './daily_lesson_day_lesson';
export class DailyLessonDay {
    constructor(data, config) {
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "dailyLessonVolumeId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "day", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isCurrent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isCompleted", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "completedCount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "dailyLessonDayLesson", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.id = data.id;
        this.dailyLessonVolumeId = data.dailyLessonVolumeId;
        this.day = data.day;
        this.isCurrent = data.isCurrent;
        this.isCompleted = data.isCompleted;
        this.completedCount = data.completedCount;
        this.dailyLessonDayLesson = data.dailyLessonDayLesson
            ? new DailyLessonDaysLesson(data.dailyLessonDayLesson, config)
            : null;
    }
    get state() {
        if (this.isCompleted)
            return 'completed';
        if (this.isCurrent)
            return 'current';
        return 'future';
    }
}
